import React from 'react';
import { valueForKeyPath as v, uuid, slugify } from '../../../utils.jsx';

import SmartTag from '../components/SmartTag.jsx';

export const ArticleFormBasics = props => {
  if (props.preview) {
    return (
      <div className="panel panel-default panel-widget">
        <div className="panel-heading">
          <h3 className="panel-title">{props.title}</h3>
        </div>
        <div className="panel-body">
          <p>{props.perex}</p>
          {props.perex2 ? <p>{props.perex2}</p> : null}
        </div>
      </div>
    );
  } else {
    return (
      <div className="panel panel-default panel-widget">
        <div className="panel-heading">
          <h3 className="panel-title">Základné údaje</h3>
        </div>
        <div className="panel-body">
          <div className="form-group">
            <label className="title">Názov</label>
            <input
              className="form-control"
              onChange={props.onChange}
              type="text"
              name="name"
              value={props.title}
              placeholder=""
            />
          </div>
          <div className="form-group">
            <label className="title">Perex</label>
            <textarea
              className="form-control"
              onChange={props.onChange}
              placeholder="Upútajte pozornosť vystižným perexom (nepovinné)"
              rows="2"
              cols="3"
              name="perex"
              value={props.perex}
            />
          </div>
          <div className="form-group">
            <label className="title">Perex na titulku</label>
            <textarea
              className="form-control"
              onChange={props.onChange}
              placeholder="Perex pre titulku - dlhší ako bežný perex"
              rows="2"
              cols="10"
              name="perex2"
              style={{ height: '10em' }}
              value={props.perex2}
            />
          </div>
          <div className="form-group">
            <div className="checkbox">
              <label>
                <input
                  type="checkbox"
                  checked={!props.perexHidden}
                  name="perexHidden"
                  onChange={props.onChange}
                />
                Zobraziť perex
              </label>
            </div>
          </div>
        </div>
      </div>
    );
  }
};

class ArticleAddWidgetButton extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      open: false,
    };

    this.open = this.open.bind(this);
    this.didSelectWidget = this.didSelectWidget.bind(this);
  }

  open() {
    this.setState({ open: !this.state.open });
  }

  didSelectWidget(type, name, e) {
    this.setState({ open: false });
    this.props.didSelectWidget(type, this.props.index);
  }

  render() {
    const grpcls =
      'btn-group btn-widget dropup' + (this.state.open ? ' open' : '');
    const widgets = [];
    for (const type in this.props.widgets) {
      const widget = this.props.widgets[type];
      if (widget['uuid']) {
        continue;
      }
      widgets.push(
        <li
          key={type}
          onClick={this.didSelectWidget.bind(this, type, widget.name)}
        >
          {widget.name}
        </li>,
      );
    }

    return (
      <div className={grpcls}>
        <button
          type="button"
          className="btn btn-success dropdown-toggle"
          onClick={this.open}
        >
          <span className="fa fa-plus-circle" /> Pridať widget{' '}
          <span className="caret" />
        </button>
        <ul className="dropdown-menu">{widgets}</ul>
      </div>
    );
  }
}
ArticleAddWidgetButton.defaultProps = {
  widgets: [],
  index: -1,
};

class UnavailableWidget extends React.Component {
  constructor(props) {
    super(props);
  }

  render() {
    return (
      <div className="panel panel-default widget-body">
        <div className="panel-heading">
          <span className="panel-title">
            <strong>Widget nedostupný</strong>
          </span>
        </div>
        <div className="panel-body">
          <div className="alert alert-danger">Widget nie je dostupný</div>
        </div>
      </div>
    );
  }
}

class ArticleContentForm extends React.Component {
  constructor(props) {
    super(props);

    this.basicDataOnChange = this.basicDataOnChange.bind(this);
    this.didAddWidget = this.didAddWidget.bind(this);
    this.didRemoveWidget = this.didRemoveWidget.bind(this);
    this.didUpdateWidget = this.didUpdateWidget.bind(this);
    this.moveWidget = this.moveWidget.bind(this);
    this.changeObject = this.changeObject.bind(this);
    this.widgetTypeAvailable = this.widgetTypeAvailable.bind(this);
    this.smartTagOnChange = this.smartTagOnChange.bind(this);
  }

  basicDataOnChange(event) {
    let a = this.props.article;
    a[event.target.name] = event.target.value;

    if (event.target.name === 'perexHidden') {
      a[event.target.name] = !event.target.checked;
    } else if (event.target.name === 'name') {
      a.urlSuggestion = slugify(event.target.value);
    }

    this.props.articleDidUpdate(a);
  }

  smartTagOnChange(smart_tags) {
    let a = this.props.article;

    // prejdem smart tagy a zmenim ich v articli
    for (let tag in smart_tags) {
      a[tag] = smart_tags[tag];
    }

    this.props.articleDidUpdate(a);
  }

  didAddWidget(type, index) {
    this.removeCKEditors();
    let a = this.props.article;
    if (!a.widgets) {
      a.widgets = [];
    }

    var widget_data = {
      type: type,
      uuid: uuid(),
    };

    if (type === 'table') {
      widget_data.table = [['', '', ''], ['', '', ''], ['', '', '']];
      widget_data.header = [];
    } else if (type === 'photo') {
      widget_data.uri = '';
      widget_data.dimensions = {
        x: 0,
        y: 0,
        w: 0,
        h: 0,
      };
    }

    // na zaciatok
    if (index === -1) {
      a.widgets.unshift(widget_data);
    } else {
      a.widgets.splice(index + 1, 0, widget_data);
    }

    this.props.articleDidUpdate(a);
  }

  didRemoveWidget(index) {
    let a = this.props.article;
    if (!a.widgets) {
      return;
    }

    a.widgets.splice(index, 1);
    this.removeCKEditors();
    this.props.articleDidUpdate(a);
  }

  removeCKEditors() {
    try {
      for (const name in window.CKEDITOR.instances) {
        window.CKEDITOR.instances[name].destroy();
      }
    } catch (err) {
      window.CKEDITOR.instances = [];
    }
  }

  didUpdateWidget(index, data) {
    let a = this.props.article;
    if (!a.widgets) {
      return;
    }
    a.widgets[index] = data;
    this.props.articleDidUpdate(a);
  }

  moveWidget(index, direction) {
    let a = this.props.article;
    if (!a.widgets) {
      return;
    }
    if (index === 0 && direction === 'up') {
      return;
    }
    if (index === a.widgets.length - 1 && direction === 'down') {
      return;
    }

    const move = a.widgets.splice(index, 1);
    let add = 0;
    if (direction === 'up') {
      add = -1;
    } else if (direction === 'down') {
      add = 1;
    }
    a.widgets.splice(index + add, 0, move[0]);

    this.props.articleDidUpdate(a);
  }

  getWidgetElement(type, props) {
    // kontrola, ci existuje widget
    if (this.widgetTypeAvailable(type)) {
      // doplnime nazov
      props.name = this.props.widgets[type].name;
      // vytvorime element widgetu
      return React.createElement(this.props.widgets[type].component, props);
    } else {
      return React.createElement(UnavailableWidget, props);
    }
  }

  changeObject(index, object, callback) {
    // let widgets = this.props.widgets;
    let article = this.props.article;
    article.widgets[index] = object;
    // widgets[index] = object;

    // this.setState({widgets: widgets}, function() {
    //     if(typeof callback === 'function') {
    //         callback();
    //     }
    // });

    this.props.articleDidUpdate(article);
  }

  widgetTypeAvailable(type) {
    for (let wtype in this.props.widgets) {
      if (wtype === type) {
        return true;
      }
    }
    return false;
  }

  render() {
    let tagId = v(this.props.contentspace_info, 'smart_tags', []);

    const widgets = [];
    const aw = v(this.props.article, 'widgets', []);
    for (let i = 0; i < aw.length; i++) {
      if (!aw[i].type) {
        continue;
      }
      widgets.push(
        <div className="row" key={i}>
          <div className="col-md-12">
            {this.getWidgetElement(aw[i].type, {
              data: aw[i],
              index: i,
              isLast: i === aw.length - 1,
              didRemoveWidget: this.didRemoveWidget,
              didUpdateWidget: this.didUpdateWidget,
              moveWidget: this.moveWidget,
              mediaManager: this.props.mediaManager,
              changeObject: this.changeObject,
              // contentSpace: this.props.article.contentspace
              contentSpace: this.props.contentspace_info._id,
            })}
          </div>
        </div>,
      );
      widgets.push(
        <div className="row" key={i + 'btn'}>
          <div className="col-md-12 text-center add-new-widget-container">
            <ArticleAddWidgetButton
              widgets={this.props.widgets}
              didSelectWidget={this.didAddWidget}
              index={i}
            />
            <div className="clearfix">&nbsp;</div>
          </div>
        </div>,
      );
    }
    return (
      <div className="row">
        {this.props.article.locked &&
        !this.props.contentspace_info.is_contentspace_admin ? (
          <div className="col-md-12">
            <div className="alert alert-danger">
              <strong>Pozor!</strong> Tento článok je uzamknutý. Pre možnosť
              jeho úpravy kontaktuje administrátora.
            </div>
          </div>
        ) : null}

        <div className="col-md-12">
          <div className="row">
            <div className="col-md-12">
              <ArticleFormBasics
                title={v(this.props.article, 'name', '')}
                perex={v(this.props.article, 'perex', '')}
                perex2={v(this.props.article, 'perex2', '')}
                perexHidden={v(this.props.article, 'perexHidden', false)}
                onChange={this.basicDataOnChange}
              />
            </div>
          </div>
          <div className="clearfix">&nbsp;</div>
          <div className="row">
            <div className="col-md-12">
              <div className="panel panel-default">
                <div className="panel-heading">
                  <span className="panel-title">
                    <strong>Tagy</strong>
                  </span>
                </div>
                <div className="panel-body">
                  <SmartTag
                    ref="smartTag"
                    tagId={tagId}
                    article={this.props.article}
                    onChange={this.smartTagOnChange}
                  />
                </div>
              </div>
            </div>
          </div>
          <div className="row">
            <div className="col-md-12 text-center add-new-widget-container">
              <ArticleAddWidgetButton
                widgets={this.props.widgets}
                didSelectWidget={this.didAddWidget}
              />
              <div className="clearfix">&nbsp;</div>
            </div>
          </div>
          {widgets}
        </div>
      </div>
    );
  }
}

export default ArticleContentForm;



// WEBPACK FOOTER //
// ./src/js/app/cm/components/ArticleContentForm.jsx